import { fetchData } from '@umu/umu-fetch';
import { IAIExpressiveEvalTemp } from '@umu/umu-types';
import API from '../../path';

export const getAiExpressiveEvalTemp = (): Promise<IListResponse<IAIExpressiveEvalTemp>> => {
    return fetchData(API.GET_AI_EXPRESSIVE_EVAL_TEMP, {
        page: 1,
        size: 50,
        type: 0, // 模板类型，0或不传：全部模板（系统模板+用户模板） 1. 系统预设模板； 2. 用户自定义模板；
    });
};
